import { PricingPlan } from "@/types/plans";
import { Grid2 as Grid } from "@mui/material";
import Plan from "./Plan";

interface PricingProps {
  plans: PricingPlan[];
  onSelect: (planId: string) => void;
}

const Pricing = ({ plans, onSelect }: PricingProps) => {
  return (
    <Grid container spacing={3} sx={{ display: "flex", alignItems: "flex-end" }}>
      {plans?.map((plan) => (
        <Grid key={plan.id} size={{ xs: 12, md: 4 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Plan plan={plan} onSelect={onSelect} />
        </Grid>
      ))}
    </Grid>
  );
};

export default Pricing;
